<script>
	import { fade } from "svelte/transition";

    export let success = false;
    export let error = false;

    export let solid = false;

    let className = '';
    export { className as class }
</script>

<div in:fade class="p-4 rounded-2xl border *:first:mt-0 *:last:mb-0
    {
        success && solid ? 'border-border-success bg-surface-success-muted text-symbols-success'
        : success ? 'border-border-success text-symbols-success'
        : error && solid ? 'border-border-danger bg-surface-danger-muted text-symbols-danger'
        : error ? 'border-border-danger text-symbols-danger'
        : solid ? 'border-border-default bg-surface-muted text-symbols-default'
        : 'border-border-default text-symbols-default'
    }
    {className}
"><slot/></div>